import React, {
  useContext,
  useEffect,
  useCallback,
  useRef,
  useState,
} from 'react'
import {
  Button,
  Grid,
  makeStyles,
  Toolbar,
  Typography,
} from '@material-ui/core'
import HelpRounded from '@material-ui/icons/HelpRounded'
import { Add, KeyboardArrowUp } from '@material-ui/icons'
import { useHistory, useLocation } from 'react-router-dom'
import { isSafari, isMobile } from 'react-device-detect'
import MarketContext from '../containers/MarketContext'
import Fundamentals from '../containers/Fundamentals'
import BehaviouralAnalysis from '../containers/BehaviouralAnalysis'
import exportNewIcon from '../assets/images/ExportNew.svg'
import recycleIcon from '../assets/images/Recycle.svg'
import { makePDF } from '../ultils/pdfUtils'
import SpinnerIcon from '../assets/images/spinner.gif'
import { Context as PortfolioContext } from '../contexts/portfolio'
import {
  clearD3Tips,
  displayPodShow0,
  getColorFromStatus,
  waiting,
} from '../ultils/dataUtil'
import charts from '../data/relationsData'
import behaviourChartConst from '../data/behaviorAnalysisChart'
import fundamental_loading from '../assets/images/Skeletons/fundamental_loading.png'
import marketContext_loading from '../assets/images/Skeletons/marketContext_loading.png'
import behavior_loading from '../assets/images/Skeletons/behavior_loading.png'
import FundamentalsCreditAnalysis from '../containers/FundamentalsCreditAnalysis'
import { getCookie, setCookieHelper } from '../ultils/cookie'
import { userService } from '../services/users.services'
import { EXPIRED_SECOND } from '../constants/Cookie'
import { getCompanyStatusWithType, RISK_TYPE } from '../ultils/chart-d3-utils'
import NoteContext from '../containers/NoteContext'
import NewsFeed from '../components/NewsFeed'
import WhatIfScenarioAnalysis from '../containers/WhatIfScenari/WhatIfScenarioAnalysis'
import SkeletonsWhatIfArticle from '../components/SletokenWhatIfArticle'
import { Alert, TIME_SHOW_ALERT } from '../components/Alert'
import BFTabs from '../components/Tabs/BFTabs'
import BFTab from '../components/Tabs/BFTab'
import ResponsiveArticle from '../components/ResponsiveArticle'
import PortfolioTodayCompanyPage from '../containers/PortfolioTodayCompanyPage'
import PortfolioLastWeek from '../containers/PortfolioLastWeek'
import ConfirmRemovePortfolioCompany from '../components/ConfirmRemovePortfolioCompany'
import NotesDataTooltipModal from '../components/NotesDataTooltipModal'
import PortfolioTooltipModal from '../components/PortfolioTooltipModal'
import SearchBoxCommon from '../components/SearchBoxCommon'
import {
  hasCompanySummaryValue,
  shouldShowEquityPriceMove,
} from '../ultils/companySummary'

const COMPACT_VIEWPORT_HEIGHT = 950
const ESTIMATED_RISK_HEADER_HEIGHT = 160

const RISK_STORY_HEIGHT = 245
const RISK_STORY_HEIGHT_COMPACT = 230

const CASE1_MAX_CHART_HEIGHT = 250
const CASE1_MIN_CHART_HEIGHT = 100

const CASE2_MIN_CHART_HEIGHT = 360
const CASE2_MAX_CHART_HEIGHT = 450

const parseBooleanFlag = (value: any) => String(value).toLowerCase() === 'true'

const useStyles = makeStyles({
  container: {
    padding: '16px 24px 0px',
    width: '100%',
    boxSizing: 'border-box',
    gap: 12,
  },
  frame: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
  },
  frameHeader: {
    height: 64,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 24px',
    background: '#EDF2F7',
    borderStyle: 'solid',
    borderColor: '#DFE4EB',
    borderWidth: '1px 1px 0px 1px',
    boxSizing: 'border-box',
  },
  frameBody: {
    flex: '1 1 auto',
    background: '#FFFFFF',
    borderStyle: 'solid',
    borderColor: '#DFE4EB',
    borderWidth: '0px 1px 1px 1px',
    padding: 24,
    boxSizing: 'border-box',
  },
  toolbar: {
    minHeight: 'unset',
    background: 'transparent',
    maxHeight: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    boxSizing: 'border-box',
    margin: 0,
    border: 'none',
    padding: 0,
  },
  companyFrame: {
    marginTop: '20px',
    marginBottom: '50px',
    borderRadius: 6,
    background: '#FFFFFF',
    boxSizing: 'border-box',
  },
  companyFrameHeader: {
    width: '100%',
    background: '#EDF2F7',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 24px',
    boxSizing: 'border-box',
  },
  companyFrameBody: {
    width: '100%',
    borderRadius: 0,
    padding: '10px 24px 16px',
    boxSizing: 'border-box',
  },
  backToPortfolioPage: {
    '&span': {
      marginLeft: 0,
    },
  },
  lgBanner: {
    width: '100%',
    backgroundPosition: 'inherit',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    marginBottom: 30,
  },
  searchCommonContainer: {
    width: 350,
  },
  headContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
  },
  headContainerButton: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
  },
  internalToggle: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginLeft: 12,
  },
  internalToggleLabel: {
    fontSize: 12,
    lineHeight: '18px',
    color: '#1B3963',
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  switchTrack: {
    position: 'relative',
    display: 'inline-block',
    width: 36,
    height: 20,
    borderRadius: 999,
    background: '#E6EAF0',
    transition: 'background 0.2s ease',
    cursor: 'pointer',
    overflow: 'hidden',
    marginRight: 10,
  },
  switchTrackActive: {
    background: '#1B3963',
  },
  switchThumb: {
    position: 'absolute',
    top: 2,
    left: 2,
    right: 'auto',
    width: 16,
    height: 16,
    borderRadius: '50%',
    background: '#FFFFFF',
    transition: 'left 0.2s ease, right 0.2s ease',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
  },
  switchThumbActive: {
    left: 'auto',
    right: 2,
  },
  buttonDeleteAndAdd: {
    minWidth: 0,
    padding: '9px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    color: '#1B3963',
    background: '#FFFFFF',
    border: '1px solid #DFE4EB',
    borderRadius: 3,
    whiteSpace: 'nowrap',
    fontWeight: 400,
    fontSize: 14,
    textTransform: 'none',
    '&:hover': {
      background: '#F6F8FB',
    },
  },
  spinnerIcon: {
    width: 20,
    marginLeft: 8,
  },
  pageTitle: {
    maxWidth: '600px',
    fontSize: 24,
    lineHeight: '28px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    marginRight: 20,
    '& span': {
      fontSize: 16,
      fontWeight: 600,
      textTransform: 'capitalize',
      marginLeft: 20,
    },
    '& .statusName': {
      fontWeight: 600,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    '& .companyName': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      maxWidth: '100%',
      fontFamily: 'Inter, sans-serif',
      fontWeight: 600,
      fontSize: 24,
      lineHeight: '28px',
      letterSpacing: 0,
      color: '#181818',
    },
  },
  title: {
    padding: 0,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: 20,
    lineHeight: '24px',
    letterSpacing: 0,
    color: '#181818',
  },
  insightsHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    width: 'fit-content',
    margin: '12px 24px 12px 0px',
  },
  companyDetail: {
    display: 'flex',
    alignItems: 'stretch',
    fontSize: 14,
    width: '100%',
    flexWrap: 'nowrap',
    gap: 0,
    padding: 0,
    overflowX: 'auto',
    '& span': {
      whiteSpace: 'nowrap',
      fontSize: 14,
      '& span': {
        fontWeight: 400,
        color: '#fff',
      },
    },
    '& .MuiButton-outlinedPrimary:hover': {
      backgroundColor: '#1B3963',
      color: '#fff',
    },
  },
  breadcrumb: {
    color: '#1B3963',
    '& .MuiBreadcrumbs-li': {
      fontSize: 12,
      '& p': {
        fontSize: 12,
      },
    },
  },
  exportBtn: {
    marginLeft: 10,
    display: 'flex',
    alignItems: 'center',
    background: '#1B3963',
    padding: '9px 12px',
    border: '1px solid #DFE4EB',
    borderRadius: 3,
    textTransform: 'none',
    fontWeight: 400,
    fontSize: 14,
    '& img': {
      marginRight: 7,
      width: 14,
      color: '#FFFFFF',
    },
    '& span': {
      color: '#FFFFFF',
    },
  },
  exportBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    boxSizing: 'border-box',
    border: '1px solid #DFE4EB',
    borderRadius: 6,
    padding: '8px 5px',
    background: '#FFFFFF',
  },
  exportBarItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '6px 18px',
    marginRight: 0,
    borderRight: '1px solid #E6EAF0',
    minHeight: 56,
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    '& span:first-child': {
      paddingRight: 0,
      marginBottom: 4,
      fontFamily: 'Inter, sans-serif',
      fontSize: 12,
      lineHeight: '18px',
      fontWeight: 400,
      letterSpacing: 0,
      color: '#757575',
      opacity: 1,
    },
    '& span:nth-child(2)': {
      marginTop: 0,
      minHeight: 'unset',
      fontFamily: 'Inter, sans-serif',
      fontSize: 14,
      lineHeight: '22px',
      fontWeight: 600,
      letterSpacing: 0,
      color: '#474747',
    },
    '&:last-child': {
      borderRight: 'none',
    },
  },
  headSectionList: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  jumpItem: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    color: 'black',
    '@media only screen and (min-width: 1200px)': {
      marginRight: 10,
    },
    '@media only screen and (min-width: 1500px)': {
      marginRight: 32,
    },
  },
  activeLink: {
    '& div': {
      color: '#3393F3',
    },
  },
  scrollHead: {
    position: 'sticky',
    top: 0,
    background: '#F5F8FF',
    zIndex: 2,
  },
  activeScrollHead: {
    background: '#FFFFFF',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
  },
  spinnerContainer: {
    width: '100%',
    height: '90vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  toolbarActiveScroll: {
    border: '1px solid #DFE4EB',
    background: '#FFFFFF',
    boxShadow: 'none',
    paddingTop: 0,
  },
  jumpItemActive: {
    color: '#3393F3',
  },
  status: {
    color: '#000',
    display: 'flex',
    alignItems: 'center',
    '& div': {
      fontWeight: 600,
      marginLeft: 10,
    },
  },
  circle: {
    height: 8,
    width: 8,
    borderRadius: '50%',
    position: 'relative',
    '& > div': {
      height: 16,
      width: 16,
      opacity: '0.35',
      borderRadius: '50%',
      position: 'absolute',
      left: '-4px',
      top: '-4px',
      margin: 0,
      'animation-name': `$backgroundColorPalette`,
      'animation-duration': '1s',
      'animation-iteration-count': 'infinite',
      'animation-direction': 'alternate',
      'animation-timing-function': 'liner',
    },
  },
  '@keyframes backgroundColorPalette': {
    '0%': {
      opacity: 0.25,
    },
    '25%': {
      opacity: 0.45,
    },
    '50%': {
      opacity: 0.55,
    },
    '75%': {
      opacity: 0.45,
    },
    '100%': {
      opacity: 0.25,
    },
  },
  divStatusHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '25px',
  },
  showStatusHeader: {
    color: '#1B3963',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 14,
    // marginTop: 10,
    '& img': {
      color: '#474747',
    },
  },
  sectionWhatIf: {
    padding: '26px 20px 20px 30px',
    marginBottom: '20px',
    background: 'white',
    border: '1px solid #DFE4EB',
    borderRadius: 5,
    boxSizing: 'border-box',
  },
  headPage: {
    padding: '0px 24px',
    height: '60px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  subTitle: {
    marginLeft: 5,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 18,
    lineHeight: 26,
    color: '#5E5E5E',
  },
  toolTip: {
    color: '#8D9CB1',
    width: 16,
    height: 16,
    fontSize: 16,
    cursor: 'pointer',
    verticalAlign: 'middle',
    marginLeft: 5,
  },
  headerTitle: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: 24,
    lineHeight: '28px',
    color: '#181818',
  },
  tabsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  riskToggle: {
    marginRight: 10,
  },
  tabsGroup: {
    width: 256,
    height: 40,
    padding: 4,
    borderRadius: 3,
    background: '#FFFFFF',
    border: 'none',
    boxSizing: 'border-box',
    minHeight: 'unset',
    '& .MuiTabs-flexContainer': {
      gap: 4,
    },
    '& .MuiTab-root.small': {
      minWidth: 122,
      maxWidth: 122,
      height: 32,
      padding: '5px 0',
      borderRadius: 3,
      fontFamily: 'Inter, sans-serif',
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '22px',
      textTransform: 'none',
    },
    '& .MuiTab-root.small .MuiTab-wrapper': {
      width: '100%',
      padding: 0,
      color: '#757575',
    },
    '& .MuiTab-root.small.Mui-selected': {
      background: '#1B3963',
      color: '#FFFFFF',
    },
    '& .MuiTab-root.small.Mui-selected .MuiTab-wrapper': {
      color: '#FFFFFF',
    },
  },
  portfolioListContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#1B3963',
    width: 150,
    height: 40,
    borderRadius: 3,
    marginLeft: 12,
    cursor: 'pointer',
  },
  portfolioListTitle: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 600,
    color: '#FFFFFF',
    marginLeft: 8,
  },
  FormatListBulletedIcon: {
    color: 'white',
    width: 22,
  },
  portfolioTable: {
    backgroundColor: '#fff',
    padding: '20px 25px',
    border: '1px solid #DFE4EB',
    borderRadius: 5,
    marginBottom: 35,
  },
  quickNoteCard: {
    height: '100%',
    background: '#FFFFFF',
    border: '1px solid #DFE4EB',
    borderRadius: 5,
    boxSizing: 'border-box',
    padding: '16px 16px 12px 16px',
    marginBottom: 10,
  },
  riskStoryCard: {
    marginTop: 10,
    background: '#FFFFFF',
    border: '1px solid #DFE4EB',
    borderRadius: 5,
    boxSizing: 'border-box',
    padding: '10px 16px 10px 16px',
    height: RISK_STORY_HEIGHT_COMPACT,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  riskStoryCardCompact: {
    // padding: '12px 16px 8px 16px',
    height: RISK_STORY_HEIGHT_COMPACT,
  },
  sideCardMatchHeight: {
    height: '100%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    '& section': {
      marginBottom: 0,
      minHeight: 0,
    },
  },
  sideCardNoMargin: {
    marginBottom: 0,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  sideColumn: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'hidden',
  },
  leftColumnMatchHeight: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    '& section': {
      marginBottom: 0,
    },
  },
  sectionDivider: {
    width:
      'calc(100% + var(--frame-padding, 24px) + var(--frame-padding, 24px))',
    height: 1,
    background: '#C1CFDF',
    margin: '20px 0',
    marginLeft: 'calc(0px - var(--frame-padding, 24px))',
    marginRight: 'calc(0px - var(--frame-padding, 24px))',
  },
  backTopBtn: {
    position: 'fixed',
    right: 24,
    bottom: 24,
    zIndex: 15,
    background: '#1B3963',
    color: '#FFF',
    minWidth: 48,
    height: 48,
    borderRadius: 24,
    boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
    '&:hover': { background: '#153053' },
    transition: 'opacity 0.2s',
  },
  hidden: { opacity: 0, pointerEvents: 'none' },
})

const CompanyPage = () => {
  const classes = useStyles()
  const {
    state,
    cleanUp,
    addTickers,
    getPrices,
    getEvents,
    getTickersOnlyInPortfolio,
    getAllTickersInUniverse,
    getScanCharts,
    getBehaviourAnalysisChartData,
    getCreditSeries,
    getNotes,
    getWhatIf,
    changeSelectedRiskTab,
    changeSelectedTab,
  } = useContext(PortfolioContext)
  const [companyInfo, setCompanyInfo] = useState<any>({})
  const [isLoading, setIsLoading] = useState(false)
  const [isStartScrolling, setIsStartScrolling] = useState(false)
  const [isInternalUser, setIsInternalUser] = useState(
    parseBooleanFlag(getCookie('analysis_flag')),
  )
  const [showInternalPanels, setShowInternalPanels] = useState(false)
  const companyDetailRef = useRef<HTMLDivElement>(null)
  const [openTooltip, setOpenTooltip] = React.useState(false)
  const [chartHeight, setChartHeight] = useState<number | null>(null)
  const [sideCardHeight, setSideCardHeight] = useState<number | null>(null)
  const [isCompactHeight, setIsCompactHeight] = useState(false)
  const [selectedRiskTypeTab, setSelectedRiskTypeTab] = useState(
    state.selectedRiskTypeTab,
  )
  const [selectedTab, setSelectedTab] = useState(state.selectedTab)
  const [showBackTop, setShowBackTop] = useState(false)
  const [openConfirmRemoveDialog, setOpenConfirmRemoveDialog] = useState(false)
  const [removeData, setRemoveData] = useState<any>(null)
  const toolbarRef = useRef<HTMLDivElement>(null)
  const chartContainerRef = useRef<HTMLDivElement>(null)
  const leftColumnRef = useRef<HTMLDivElement>(null)
  const companyFrameHeaderRef = useRef<HTMLDivElement>(null)
  const riskWrapperRef = useRef<HTMLDivElement>(null)
  const sideHeightRafRef = useRef<number | null>(null)
  const autoScrollDoneRef = useRef(false)
  const advancedPanelsFetchedRef = useRef<string | null>(null)

  const framePadding = !isMobile && isCompactHeight ? 20 : 24
  const companyFrameBodyStyle = {
    ...(!isMobile && isCompactHeight
      ? { padding: '10px 20px 12px' }
      : undefined),
    '--frame-padding': `${framePadding}px`,
  } as React.CSSProperties

  const firstNotesData = React.useMemo(() => {
    const notesData = state?.notesData
    if (Array.isArray(notesData)) return notesData[0]
    if (Array.isArray(notesData?.history)) return notesData.history[0]
    if (Array.isArray(notesData?.notes_history))
      return notesData.notes_history[0]
    if (Array.isArray(notesData?.note_history)) return notesData.note_history[0]
    if (Array.isArray(notesData?.signal_history))
      return notesData.signal_history[0]
    if (Array.isArray(notesData?.signals)) return notesData.signals[0]
    if (Array.isArray(notesData?.data)) return notesData.data[0]
    return notesData
  }, [state?.notesData])

  const hasNotesData =
    !state.notesDataLoading && !!firstNotesData?.signal_overview
  const showNotesContext =
    hasNotesData && companyInfo?.risk_outlook !== 'Neutral'
  const quickNoteText =
    typeof firstNotesData?.signal_overview === 'string'
      ? firstNotesData.signal_overview
      : ''
  const quickNoteTextLength = quickNoteText.length

  const latestRiskStoryData = React.useMemo(() => {
    const events = state?.marketContext?.eventData ?? []
    const riskStories = events.filter(
      (item: any) => item.signal_type === 'Risk Story',
    )
    if (!riskStories.length) {
      return []
    }
    return [...riskStories]
      .sort(
        (a: any, b: any) =>
          new Date(b.date).getTime() - new Date(a.date).getTime(),
      )
      .slice(0, 2)
  }, [state?.marketContext?.eventData])

  const isNeutralRiskOutlook = companyInfo?.risk_outlook === 'Neutral'
  const quickNoteFontSize = !isMobile
    ? isNeutralRiskOutlook
      ? 15
      : quickNoteTextLength >= 1290
      ? 12
      : quickNoteTextLength > 1085
      ? 13.5
      : 15
    : undefined
  const riskStoryFontSize = !isMobile && isNeutralRiskOutlook ? 15 : undefined

  const clampValue = useCallback(
    (min: number, value: number, max: number) =>
      Math.max(min, Math.min(max, value)),
    [],
  )

  const computeAvailableRiskHeight = useCallback(() => {
    const headerEl =
      companyFrameHeaderRef.current ||
      toolbarRef.current ||
      companyDetailRef.current
    const riskEl = riskWrapperRef.current
    if (!headerEl || !riskEl) return null
    const headerTop = headerEl.getBoundingClientRect().top
    const riskTop = riskEl.getBoundingClientRect().top
    const offset = Math.max(0, riskTop - headerTop)
    const vh = window.innerHeight || 0
    if (!vh) return null
    return Math.max(0, vh - offset)
  }, [])

  const computeLeftOverhead = useCallback(() => {
    const leftEl = leftColumnRef.current
    const chartEl = chartContainerRef.current
    if (!leftEl || !chartEl) return ESTIMATED_RISK_HEADER_HEIGHT
    const leftHeight = leftEl.getBoundingClientRect().height
    const chartHeightMeasured = chartEl.getBoundingClientRect().height
    if (!leftHeight || !chartHeightMeasured) {
      return ESTIMATED_RISK_HEADER_HEIGHT
    }
    const overhead = leftHeight - chartHeightMeasured
    return overhead > 0 ? overhead : ESTIMATED_RISK_HEADER_HEIGHT
  }, [])

  const computeCase1ChartHeight = useCallback(
    (vh: number, availableHeight: number | null, overhead: number) => {
      const riskStoryHeight = isCompactHeight
        ? RISK_STORY_HEIGHT_COMPACT
        : RISK_STORY_HEIGHT
      const preferred =
        availableHeight !== null
          ? availableHeight - riskStoryHeight - overhead
          : Math.floor(vh * 0.32)
      const minHeight = isCompactHeight
        ? CASE1_MIN_CHART_HEIGHT
        : CASE1_MIN_CHART_HEIGHT + 110

      return clampValue(minHeight, preferred, CASE1_MAX_CHART_HEIGHT)
    },
    [clampValue, isCompactHeight],
  )

  const computeCase2ChartHeight = useCallback(
    (vh: number, availableHeight: number | null, overhead: number) => {
      const preferred =
        availableHeight !== null
          ? availableHeight - overhead
          : Math.floor(vh * 0.5)
      const minHeight = isCompactHeight
        ? CASE2_MIN_CHART_HEIGHT
        : CASE2_MIN_CHART_HEIGHT + 80
      return clampValue(minHeight, preferred, CASE2_MAX_CHART_HEIGHT)
    },
    [clampValue, isCompactHeight],
  )

  const updateFixedHeights = useCallback(() => {
    if (isMobile) return
    if (state.marketContext.eventLoading || state.marketContext.priceLoading) {
      return
    }

    const vh = window.innerHeight || 0
    const compact = vh > 0 && vh < COMPACT_VIEWPORT_HEIGHT
    setIsCompactHeight(prev => (prev !== compact ? compact : prev))

    const availableHeight = computeAvailableRiskHeight()
    const overhead = computeLeftOverhead()
    const nextChartHeight = showNotesContext
      ? computeCase1ChartHeight(vh, availableHeight, overhead)
      : computeCase2ChartHeight(vh, availableHeight, overhead)
    setChartHeight(nextChartHeight)

    if (sideHeightRafRef.current) {
      window.cancelAnimationFrame(sideHeightRafRef.current)
    }
    sideHeightRafRef.current = window.requestAnimationFrame(() => {
      const leftEl = leftColumnRef.current
      if (!leftEl) return
      const leftHeight = leftEl.getBoundingClientRect().height
      if (!leftHeight) return
      setSideCardHeight(prev =>
        prev !== null && Math.abs(prev - leftHeight) < 2 ? prev : leftHeight,
      )
    })
  }, [
    isMobile,
    state.marketContext.eventLoading,
    state.marketContext.priceLoading,
    showNotesContext,
    computeAvailableRiskHeight,
    computeLeftOverhead,
    computeCase1ChartHeight,
    computeCase2ChartHeight,
  ])

  useEffect(() => {
    if (isMobile) return undefined
    updateFixedHeights()
    return () => {
      if (sideHeightRafRef.current) {
        window.cancelAnimationFrame(sideHeightRafRef.current)
        sideHeightRafRef.current = null
      }
    }
  }, [
    isMobile,
    state.marketContext.eventLoading,
    state.marketContext.priceLoading,
    showNotesContext,
    latestRiskStoryData?.length,
    updateFixedHeights,
  ])

  useEffect(() => {
    if (isMobile) return undefined
    const handleResize = () => {
      updateFixedHeights()
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isMobile, updateFixedHeights])

  const history = useHistory()
  const location = useLocation()

  const handleClickOpenTooltip = () => {
    setOpenTooltip(true)
  }

  const toggleInternalPanels = () => {
    setShowInternalPanels(prev => !prev)
  }

  const handleInternalToggleKeyDown = (
    event: React.KeyboardEvent<HTMLDivElement>,
  ) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      toggleInternalPanels()
    }
  }

  const setInternalFromResponse = (response: any) => {
    const analysisFlagValue =
      response?.analysis_flag ?? response?.data?.analysis_flag
    if (analysisFlagValue === undefined || analysisFlagValue === null) return
    setCookieHelper('analysis_flag', analysisFlagValue, EXPIRED_SECOND)
    setIsInternalUser(parseBooleanFlag(analysisFlagValue))
  }

  const baseFromDate = '2017-01-03'
  const fromDateForPriceAndCredit = '2020-01-01'
  const baseToDate = '2030-01-01'

  const changeTabView = (event: React.ChangeEvent<{}>, newValue?: any) => {
    setSelectedTab(newValue)
    changeSelectedTab(newValue)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const changeRiskTypeTabView = (
    event: React.ChangeEvent<{}>,
    newValue?: any,
  ) => {
    setSelectedRiskTypeTab(newValue)
    changeSelectedRiskTab(newValue)
  }

  const onHandleScroll = (evt: any) => {
    const scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop
    setIsStartScrolling(scrollPosition !== 0)

    const scrollY = window.pageYOffset || document.documentElement.scrollTop
    setIsStartScrolling(scrollY !== 0)
    setShowBackTop(scrollY > 300)
  }

  useEffect(() => {
    window.addEventListener('scroll', onHandleScroll)
    return () => window.removeEventListener('scroll', onHandleScroll)
  }, [])

  const tickerId = window.location.pathname.split('/')[2]
    ? window.location.pathname.split('/')[2]
    : 'RVA.AU'

  useEffect(() => {
    setShowInternalPanels(false)
    advancedPanelsFetchedRef.current = null
  }, [tickerId])

  useEffect(() => {
    if (!isInternalUser) {
      setShowInternalPanels(false)
    }
  }, [isInternalUser])

  const companyExistedInPortfolio = React.useMemo(
    () => state.tickersInPortfolio.map((i: any) => i.ticker).includes(tickerId),
    [state.tickersInPortfolio, tickerId],
  )
  const companyAddRequestPending = React.useMemo(
    () => (state.tickersAddRequestPending || []).includes(tickerId),
    [state.tickersAddRequestPending, tickerId],
  )
  const canDeleteCompanyFromPortfolio =
    companyExistedInPortfolio || companyAddRequestPending

  const printDocument = async () => {
    const ignoreElementItems = [
      'headSectionList',
      'exportToPdfBtn',
      'addToPortfolioBtn',
      'filterByBox',
      'deleteFromPortfolioBtn',
      'chartContentCompany',
      'fundamental',
      'fundamentalCreditAnalysis',
      'behavioural',
      'postRiskStory',
      'sectionDividerAfterBehavioural',
      'sectionDividerAfterFundamental',
      'sectionDividerAfterCredit',
      'whatIf',
      ...charts.map(c => `expandChartBtn-chart-${c.id}`),
      ...behaviourChartConst.map(
        c => `expandBehaviorAnalysisChartBtn-${c.title}`,
      ),
    ]
    setIsLoading(true)
    await makePDF(
      'companyPage',
      `${tickerId}_report_${new Date().toDateString()}`,
      ignoreElementItems,
    )
    setIsLoading(false)
  }

  useEffect(() => {
    clearD3Tips()
  }, [])

  const addToPortfolio = () => {
    const userId = getCookie('userId')
    addTickers(userId, tickerId)
  }

  const deleteFromPortfolio = () => {
    setOpenConfirmRemoveDialog(true)
    setRemoveData(tickerId)
  }

  const getAllTickersInUniverses = useCallback(
    (userId: string) => {
      if (
        !state?.tickersInUniverse ||
        (Array.isArray(state?.tickersInUniverse) &&
          state?.tickersInUniverse.length === 0)
      ) {
        getAllTickersInUniverse(userId)
      }
    },
    [state?.tickersInUniverse],
  )

  const getTickersOnlyInPortfolios = useCallback(
    (userId: string) => {
      if (
        !state?.tickersInPortfolio ||
        (Array.isArray(state?.tickersInPortfolio) &&
          state?.tickersInPortfolio.length === 0)
      ) {
        getTickersOnlyInPortfolio(userId)
      }
    },
    [state?.tickersInPortfolio],
  )

  const getCompanyData = async (
    tickerId: string,
    fromDate: string,
    toDate: string,
    userId: string,
    fromDateForPriceAndCredit: string | null = null,
  ) => {
    getTickersOnlyInPortfolios(userId)
    getNotes(tickerId, userId)
    getPrices(tickerId, fromDateForPriceAndCredit ?? fromDate, toDate, userId)
    getEvents(tickerId, userId)
  }

  const getAdvancedCompanyData = async (
    tickerId: string,
    fromDate: string,
    toDate: string,
    userId: string,
    fromDateForPriceAndCredit: string | null = null,
  ) => {
    getWhatIf(tickerId, userId)
    getScanCharts(tickerId, userId)
    getBehaviourAnalysisChartData(userId, tickerId, fromDate, toDate)
    getCreditSeries(
      userId,
      tickerId,
      fromDateForPriceAndCredit ?? fromDate,
      toDate,
    )
  }

  const maybeFetchAdvancedCompanyData = (
    userId: string,
    internalFlag: boolean,
  ) => {
    if (!internalFlag) return
    if (advancedPanelsFetchedRef.current === tickerId) return
    advancedPanelsFetchedRef.current = tickerId
    getAdvancedCompanyData(
      tickerId,
      baseFromDate,
      baseToDate,
      userId,
      fromDateForPriceAndCredit,
    )
  }

  useEffect(() => {
    const previousScrollRestoration = window.history.scrollRestoration
    window.history.scrollRestoration = 'manual'
    return () => {
      window.history.scrollRestoration = previousScrollRestoration
    }
  }, [])

  const scrollToCompanyHeader = useCallback(() => {
    const targetRef =
      companyFrameHeaderRef.current ||
      toolbarRef.current ||
      companyDetailRef.current
    if (!targetRef) return
    const y = targetRef.getBoundingClientRect().top + window.pageYOffset + 5
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' })
  }, [])

  useEffect(() => {
    autoScrollDoneRef.current = false
  }, [tickerId])

  useEffect(() => {
    const navState = location.state as { fromChart?: boolean }
    if (navState?.fromChart) {
      scrollToCompanyHeader()
      history.replace({ ...location, state: {} })
    }
  }, [location.state, scrollToCompanyHeader])

  useEffect(() => {
    if (isMobile) return undefined
    if (state.loading) return undefined
    if (autoScrollDoneRef.current) return undefined
    autoScrollDoneRef.current = true
    const rafId = window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        scrollToCompanyHeader()
      })
    })
    return () => window.cancelAnimationFrame(rafId)
  }, [isMobile, state.loading, scrollToCompanyHeader, tickerId])

  useEffect(() => {
    const fetchingMarketContextData = async () => {
      await cleanUp()
      if (!getCookie('userId')) {
        userService
          .getUser(getCookie('email'))
          .then(async res => {
            setCookieHelper('userId', res.data, EXPIRED_SECOND)
            const internalFlag = parseBooleanFlag(
              res?.analysis_flag ?? res?.data?.analysis_flag,
            )
            setInternalFromResponse(res)
            const userId = res.data
            getAllTickersInUniverses(userId)
            getCompanyData(
              tickerId,
              baseFromDate,
              baseToDate,
              userId,
              fromDateForPriceAndCredit,
            )
            maybeFetchAdvancedCompanyData(userId, internalFlag)
          })
          .catch(() => {})
      } else {
        const userId = getCookie('userId')
        getAllTickersInUniverses(userId)
        getCompanyData(
          tickerId,
          baseFromDate,
          baseToDate,
          userId,
          fromDateForPriceAndCredit,
        )
        maybeFetchAdvancedCompanyData(
          userId,
          parseBooleanFlag(getCookie('analysis_flag')),
        )
        if (!getCookie('analysis_flag') && getCookie('accessToken')) {
          userService
            .getUser(getCookie('email'))
            .then(res => {
              const internalFlag = parseBooleanFlag(
                res?.analysis_flag ?? res?.data?.analysis_flag,
              )
              setInternalFromResponse(res)
              maybeFetchAdvancedCompanyData(res.data, internalFlag)
            })
            .catch(() => {})
        }
      }
    }
    fetchingMarketContextData()
  }, [tickerId])

  useEffect(() => {
    if (state.tickersInUniverse.length > 0) {
      let data = state.tickersInUniverse.filter(
        (item: any) => item.ticker === tickerId,
      )[0]
      if (data) {
        setCompanyInfo(data)
      } else {
        const showContentNotFound = async () => {
          Alert.info(
            'This company is currently not available in our coverage. Navigating back to the portfolio page',
          )
          await waiting(TIME_SHOW_ALERT)
          history.push('/portfolio')
        }
        showContentNotFound()
      }
    }
  }, [state.tickersInUniverse, tickerId])

  const canShowAdvancedPanels = isInternalUser && showInternalPanels

  return (
    <>
      <div id="companyPage" className={classes.container}>
        <div id="chartContentCompany">
          <div className={classes.frame}>
            <div className={classes.frameHeader}>
              <div>
                <span className={classes.headerTitle}>Portfolio</span>
                <span className={classes.subTitle}>
                  (Heat-Map of Risk in your Portfolio Companies)
                </span>
                <HelpRounded
                  className={classes.toolTip}
                  key="1"
                  onClick={() => handleClickOpenTooltip()}
                />
              </div>
              <div className={classes.tabsContainer}>
                {/* {state.creditRiskDataExisted && (
                  <div className={classes.riskToggle}>
                    <BFTabs
                      size="small"
                      value={selectedRiskTypeTab}
                      onChange={changeRiskTypeTabView}
                    >
                      <BFTab
                        size="small"
                        label="Risk Outlook"
                        value={RISK_TYPE.EQUITY}
                      />
                    </BFTabs>
                  </div>
                )} */}
                <BFTabs
                  size="small"
                  value={selectedTab}
                  onChange={changeTabView}
                  className={classes.tabsGroup}
                >
                  <BFTab size="small" label="Today" value={0} />
                  <BFTab size="small" label="Week to Date" value={1} />
                </BFTabs>
              </div>
            </div>
            <div className={classes.frameBody}>
              {state.loading && (
                <div className={classes.portfolioTable}>
                  <ResponsiveArticle />
                </div>
              )}
              {!state.loading && (
                <div>
                  {selectedTab === 0 ? (
                    <PortfolioTodayCompanyPage
                      tickers={state.tickersInPortfolio}
                      riskType={selectedRiskTypeTab}
                      tickerId={tickerId}
                    />
                  ) : (
                    <PortfolioLastWeek
                      tickers={state.tickersInPortfolio}
                      riskType={selectedRiskTypeTab}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div ref={companyDetailRef} className={classes.companyFrame}>
          <Toolbar
            ref={toolbarRef}
            className={`${classes.toolbar} ${
              isStartScrolling ? classes.toolbarActiveScroll : ''
            }`}
          >
            <div
              ref={companyFrameHeaderRef}
              className={classes.companyFrameHeader}
            >
              <div className={classes.headContainer}>
                <Typography component="div" className={classes.pageTitle}>
                  <div className="companyName">{companyInfo?.proper_name}</div>
                </Typography>
                <div className={classes.headContainerButton}>
                  {isInternalUser && (
                    <div className={classes.internalToggle}>
                      {/* <span className={classes.internalToggleLabel}>
                        Show analysis
                      </span> */}
                      <div
                        className={`${classes.switchTrack} ${
                          showInternalPanels ? classes.switchTrackActive : ''
                        }`}
                        role="switch"
                        aria-checked={showInternalPanels}
                        aria-label="Show analysis panels"
                        tabIndex={0}
                        onClick={toggleInternalPanels}
                        onKeyDown={handleInternalToggleKeyDown}
                      >
                        <div
                          className={`${classes.switchThumb} ${
                            showInternalPanels ? classes.switchThumbActive : ''
                          }`}
                        />
                      </div>
                    </div>
                  )}
                  <div className={classes.searchCommonContainer}>
                    <SearchBoxCommon
                      insidePage="company"
                      searchList={state.tickersInUniverse || []}
                      height={42}
                    />
                  </div>
                  {!companyExistedInPortfolio && !companyAddRequestPending && (
                    <Button
                      disabled={state?.loadingAddDeleteTicker}
                      onClick={addToPortfolio}
                      startIcon={<Add />}
                      className={classes.buttonDeleteAndAdd}
                      id="addToPortfolioBtn"
                    >
                      Add to portfolio
                      {!!state?.loadingAddDeleteTicker && (
                        <img
                          src={SpinnerIcon}
                          alt=""
                          className={classes.spinnerIcon}
                        />
                      )}
                    </Button>
                  )}
                  {canDeleteCompanyFromPortfolio && (
                    <Button
                      disabled={state?.loadingAddDeleteTicker}
                      onClick={deleteFromPortfolio}
                      className={classes.buttonDeleteAndAdd}
                      startIcon={<img alt="" src={recycleIcon} />}
                      id="deleteFromPortfolioBtn"
                    >
                      Delete from Portfolio
                      {!!state?.loadingAddDeleteTicker && (
                        <img
                          src={SpinnerIcon}
                          alt=""
                          className={classes.spinnerIcon}
                        />
                      )}
                    </Button>
                  )}
                  {!isSafari && (
                    <Button
                      disabled={isLoading}
                      id="exportToPdfBtn"
                      className={classes.exportBtn}
                      onClick={() => {
                        printDocument()
                      }}
                    >
                      <img alt="" src={exportNewIcon} />
                      Export to PDF
                      {!!isLoading && (
                        <img
                          alt="spinner"
                          src={SpinnerIcon}
                          className={classes.spinnerIcon}
                        />
                      )}
                    </Button>
                  )}
                </div>
              </div>
            </div>
            <div
              className={classes.companyFrameBody}
              style={companyFrameBodyStyle}
            >
              <div className={classes.exportBar}>
                <div className={classes.companyDetail}>
                  <div className={classes.exportBarItem}>
                    <span>Ticker</span>
                    <span>{companyInfo?.ticker}</span>
                  </div>
                  <div className={classes.exportBarItem}>
                    <span>Sector</span>
                    <span>{companyInfo?.factset_sector_desc}</span>
                  </div>
                  <div className={classes.exportBarItem}>
                    <span>Industry</span>
                    <span>{companyInfo?.industry}</span>
                  </div>
                  {hasCompanySummaryValue(companyInfo?.risk_score) && (
                    <div className={classes.exportBarItem}>
                      <span>Risk Score</span>
                      <span>{companyInfo?.risk_score}</span>
                    </div>
                  )}
                  <div className={classes.exportBarItem}>
                    <span>Risk Outlook</span>
                    <span>
                      {companyInfo?.risk_outlook && (
                        <div className={classes.showStatusHeader}>
                          <div className={classes.status}>
                            <div
                              className={classes.circle}
                              style={{
                                backgroundColor: getColorFromStatus(
                                  companyInfo?.risk_outlook,
                                ),
                              }}
                            >
                              <div
                                style={{
                                  backgroundColor: getColorFromStatus(
                                    companyInfo?.risk_outlook,
                                  ),
                                }}
                              />
                            </div>
                            <div
                              style={{
                                color: getColorFromStatus(
                                  companyInfo?.risk_outlook,
                                ),
                              }}
                              className="statusName"
                            >
                              {getCompanyStatusWithType(
                                companyInfo?.risk_outlook,
                                'Equity',
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </span>
                  </div>
                  {!!companyInfo?.risk_outlook_date &&
                    companyInfo?.risk_outlook !== 'Neutral' && (
                      <div className={classes.exportBarItem}>
                        <span>Date of last Risk Revision</span>
                        <span>{companyInfo?.risk_outlook_date}</span>
                      </div>
                    )}
                  {shouldShowEquityPriceMove(companyInfo) && (
                    <div className={classes.exportBarItem}>
                      <span>Equity Price Move since last Risk Revision</span>
                      <span
                        style={{
                          color: `${
                            parseFloat(companyInfo?.returns) > 0
                              ? 'green'
                              : 'red'
                          }`,
                        }}
                      >
                        {companyInfo?.returns}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div style={{ margin: '10px 0px 10px' }}>
                {state.marketContext.eventLoading ||
                state.marketContext.priceLoading ? (
                  <div
                    className={classes.lgBanner}
                    style={{
                      backgroundImage: `url(${marketContext_loading})`,
                      height: 625,
                    }}
                  />
                ) : (
                  <div id="risk" ref={riskWrapperRef}>
                    <Grid container spacing={2} alignItems="flex-start">
                      <Grid
                        item
                        xs={12}
                        md={7}
                        ref={leftColumnRef}
                        className={classes.leftColumnMatchHeight}
                      >
                        <MarketContext
                          tickerId={tickerId}
                          chartHeight={chartHeight ?? undefined}
                          chartContainerRef={chartContainerRef}
                          riskStatus={{
                            color: getColorFromStatus(
                              companyInfo?.risk_outlook,
                            ),
                            text: getCompanyStatusWithType(
                              companyInfo?.risk_outlook,
                              'Equity',
                            ),
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={5}
                        className={classes.sideColumn}
                        data-pdf-expand="height"
                        style={
                          sideCardHeight !== null
                            ? { height: sideCardHeight }
                            : undefined
                        }
                      >
                        {showNotesContext ? (
                          <div
                            id="notes"
                            className={
                              sideCardHeight !== null
                                ? classes.sideCardMatchHeight
                                : undefined
                            }
                            data-pdf-expand="height"
                          >
                            <NoteContext
                              tickerId={tickerId}
                              textFontSize={quickNoteFontSize}
                            />
                          </div>
                        ) : (
                          <div
                            className={`${classes.quickNoteCard} ${
                              sideCardHeight !== null
                                ? classes.sideCardNoMargin
                                : ''
                            }`}
                            data-pdf-expand="height"
                          >
                            <NewsFeed
                              latestRiskStoryData={latestRiskStoryData}
                              title="Risk Story"
                              subTitle="Continual Updated Company Risk"
                              showContentBorder={false}
                              splitColumns={false}
                              fullHeight
                              textFontSize={riskStoryFontSize}
                              dateFontSize={riskStoryFontSize}
                            />
                          </div>
                        )}
                      </Grid>
                    </Grid>
                    {showNotesContext && (
                      <div
                        className={`${classes.riskStoryCard} ${
                          !isMobile && isCompactHeight
                            ? classes.riskStoryCardCompact
                            : ''
                        }`}
                        data-pdf-expand="height"
                      >
                        <NewsFeed
                          latestRiskStoryData={latestRiskStoryData}
                          title="Risk Story"
                          subTitle="Continual Updated Company Risk"
                          showContentBorder={false}
                          splitColumns
                          fullHeight
                          textFontSize={riskStoryFontSize}
                          dateFontSize={riskStoryFontSize}
                        />
                      </div>
                    )}
                  </div>
                )}

                {canShowAdvancedPanels && (
                  <div id="postRiskStory">
                    {state.behaviorChartLoading ? (
                      <div
                        className={classes.lgBanner}
                        style={{
                          backgroundImage: `url(${behavior_loading})`,
                          height: 400,
                          margin: '20px 24px 20px 24px',
                        }}
                      />
                    ) : (
                      state.showBehavioural && (
                        <>
                          <div className={classes.sectionDivider} />
                          <div id="behavioural">
                            <BehaviouralAnalysis tickerId={tickerId} />
                          </div>
                        </>
                      )
                    )}

                    <div
                      id="sectionDividerAfterBehavioural"
                      className={classes.sectionDivider}
                    />

                    {state.fundamentalLoading ? (
                      <div
                        className={classes.lgBanner}
                        style={{
                          backgroundImage: `url(${fundamental_loading})`,
                          height: 840,
                          margin: '0px 24px 20px 24px',
                        }}
                      />
                    ) : (
                      state.showFundamentals && (
                        <div id="fundamental">
                          <Fundamentals tickerId={tickerId} />
                        </div>
                      )
                    )}

                    <div
                      id="sectionDividerAfterFundamental"
                      className={classes.sectionDivider}
                    />

                    {!state.creditLoading &&
                      !state?.marketContext?.priceLoading &&
                      !state?.marketContext?.eventLoading &&
                      state.showCreditChart && (
                        <div id="fundamentalCreditAnalysis">
                          <FundamentalsCreditAnalysis
                            companyInfo={companyInfo}
                            riskStatus={{
                              color: getColorFromStatus(
                                companyInfo?.credit_status,
                              ),
                              text: getCompanyStatusWithType(
                                companyInfo?.credit_status,
                                'Credit',
                              ),
                            }}
                          />
                        </div>
                      )}

                    <div
                      id="sectionDividerAfterCredit"
                      className={classes.sectionDivider}
                    />

                    <div id="whatIf">
                      {state?.whatIfLoading && (
                        <div className={classes.sectionWhatIf}>
                          <SkeletonsWhatIfArticle />
                        </div>
                      )}
                      {!state?.whatIfLoading &&
                        state?.whatIfDataDetail?.scenario_1_fields && (
                          <WhatIfScenarioAnalysis />
                        )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Toolbar>
        </div>
      </div>

      <Button
        className={`${classes.backTopBtn} ${
          !showBackTop ? classes.hidden : ''
        }`}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <KeyboardArrowUp />
      </Button>

      <ConfirmRemovePortfolioCompany
        open={openConfirmRemoveDialog}
        setOpen={setOpenConfirmRemoveDialog}
        removeData={removeData}
        setRemoveData={setRemoveData}
      />

      <PortfolioTooltipModal
        open={openTooltip}
        handleClose={() => {
          setOpenTooltip(false)
        }}
      />
    </>
  )
}

export default CompanyPage
